import { type PropsWithChildren } from "react";

export function NoopSaveProvider(
  props: PropsWithChildren & { workoutItemId: string },
) {
  return props.children;
}
